/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var user_pb = require('./user_pb.js')
const proto = {};
proto.proto = require('./task_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.TaskServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.TaskServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TasksRequest,
 *   !proto.proto.Tasks>}
 */
const methodDescriptor_TaskService_Index = new grpc.web.MethodDescriptor(
  '/proto.TaskService/Index',
  grpc.web.MethodType.UNARY,
  proto.proto.TasksRequest,
  proto.proto.Tasks,
  /**
   * @param {!proto.proto.TasksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Tasks.deserializeBinary
);


/**
 * @param {!proto.proto.TasksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Tasks)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Tasks>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TaskServiceClient.prototype.index =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TaskService/Index',
      request,
      metadata || {},
      methodDescriptor_TaskService_Index,
      callback);
};


/**
 * @param {!proto.proto.TasksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Tasks>}
 *     Promise that resolves to the response
 */
proto.proto.TaskServicePromiseClient.prototype.index =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TaskService/Index',
      request,
      metadata || {},
      methodDescriptor_TaskService_Index);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TaskRequest,
 *   !proto.proto.Task>}
 */
const methodDescriptor_TaskService_Add = new grpc.web.MethodDescriptor(
  '/proto.TaskService/Add',
  grpc.web.MethodType.UNARY,
  proto.proto.TaskRequest,
  proto.proto.Task,
  /**
   * @param {!proto.proto.TaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Task.deserializeBinary
);


/**
 * @param {!proto.proto.TaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Task)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Task>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TaskServiceClient.prototype.add =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TaskService/Add',
      request,
      metadata || {},
      methodDescriptor_TaskService_Add,
      callback);
};


/**
 * @param {!proto.proto.TaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Task>}
 *     Promise that resolves to the response
 */
proto.proto.TaskServicePromiseClient.prototype.add =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TaskService/Add',
      request,
      metadata || {},
      methodDescriptor_TaskService_Add);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TaskRequest,
 *   !proto.proto.Task>}
 */
const methodDescriptor_TaskService_Update = new grpc.web.MethodDescriptor(
  '/proto.TaskService/Update',
  grpc.web.MethodType.UNARY,
  proto.proto.TaskRequest,
  proto.proto.Task,
  /**
   * @param {!proto.proto.TaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Task.deserializeBinary
);


/**
 * @param {!proto.proto.TaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Task)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Task>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TaskServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TaskService/Update',
      request,
      metadata || {},
      methodDescriptor_TaskService_Update,
      callback);
};


/**
 * @param {!proto.proto.TaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Task>}
 *     Promise that resolves to the response
 */
proto.proto.TaskServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TaskService/Update',
      request,
      metadata || {},
      methodDescriptor_TaskService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TasksRequest,
 *   !proto.proto.Tasks>}
 */
const methodDescriptor_TaskService_Completed = new grpc.web.MethodDescriptor(
  '/proto.TaskService/Completed',
  grpc.web.MethodType.UNARY,
  proto.proto.TasksRequest,
  proto.proto.Tasks,
  /**
   * @param {!proto.proto.TasksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Tasks.deserializeBinary
);


/**
 * @param {!proto.proto.TasksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Tasks)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Tasks>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TaskServiceClient.prototype.completed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TaskService/Completed',
      request,
      metadata || {},
      methodDescriptor_TaskService_Completed,
      callback);
};


/**
 * @param {!proto.proto.TasksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Tasks>}
 *     Promise that resolves to the response
 */
proto.proto.TaskServicePromiseClient.prototype.completed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TaskService/Completed',
      request,
      metadata || {},
      methodDescriptor_TaskService_Completed);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CommentServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CommentServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CommentRequest,
 *   !proto.proto.CommentsResponse>}
 */
const methodDescriptor_CommentService_Create = new grpc.web.MethodDescriptor(
  '/proto.CommentService/Create',
  grpc.web.MethodType.UNARY,
  proto.proto.CommentRequest,
  proto.proto.CommentsResponse,
  /**
   * @param {!proto.proto.CommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CommentsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CommentServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CommentService/Create',
      request,
      metadata || {},
      methodDescriptor_CommentService_Create,
      callback);
};


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CommentsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CommentServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CommentService/Create',
      request,
      metadata || {},
      methodDescriptor_CommentService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CommentRequest,
 *   !proto.proto.CommentsResponse>}
 */
const methodDescriptor_CommentService_Read = new grpc.web.MethodDescriptor(
  '/proto.CommentService/Read',
  grpc.web.MethodType.UNARY,
  proto.proto.CommentRequest,
  proto.proto.CommentsResponse,
  /**
   * @param {!proto.proto.CommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CommentsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CommentServiceClient.prototype.read =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CommentService/Read',
      request,
      metadata || {},
      methodDescriptor_CommentService_Read,
      callback);
};


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CommentsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CommentServicePromiseClient.prototype.read =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CommentService/Read',
      request,
      metadata || {},
      methodDescriptor_CommentService_Read);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CommentRequest,
 *   !proto.proto.CommentsResponse>}
 */
const methodDescriptor_CommentService_Update = new grpc.web.MethodDescriptor(
  '/proto.CommentService/Update',
  grpc.web.MethodType.UNARY,
  proto.proto.CommentRequest,
  proto.proto.CommentsResponse,
  /**
   * @param {!proto.proto.CommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CommentsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CommentServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CommentService/Update',
      request,
      metadata || {},
      methodDescriptor_CommentService_Update,
      callback);
};


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CommentsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CommentServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CommentService/Update',
      request,
      metadata || {},
      methodDescriptor_CommentService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CommentRequest,
 *   !proto.proto.CommentsResponse>}
 */
const methodDescriptor_CommentService_Delete = new grpc.web.MethodDescriptor(
  '/proto.CommentService/Delete',
  grpc.web.MethodType.UNARY,
  proto.proto.CommentRequest,
  proto.proto.CommentsResponse,
  /**
   * @param {!proto.proto.CommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CommentsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CommentServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CommentService/Delete',
      request,
      metadata || {},
      methodDescriptor_CommentService_Delete,
      callback);
};


/**
 * @param {!proto.proto.CommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CommentsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CommentServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CommentService/Delete',
      request,
      metadata || {},
      methodDescriptor_CommentService_Delete);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.ProjectServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.ProjectServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ProjectsRequest,
 *   !proto.proto.ProjectResponse>}
 */
const methodDescriptor_ProjectService_Index = new grpc.web.MethodDescriptor(
  '/proto.ProjectService/Index',
  grpc.web.MethodType.UNARY,
  proto.proto.ProjectsRequest,
  proto.proto.ProjectResponse,
  /**
   * @param {!proto.proto.ProjectsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ProjectResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ProjectServiceClient.prototype.index =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ProjectService/Index',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Index,
      callback);
};


/**
 * @param {!proto.proto.ProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ProjectResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ProjectServicePromiseClient.prototype.index =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ProjectService/Index',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Index);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ProjectRequest,
 *   !proto.proto.ProjectResponse>}
 */
const methodDescriptor_ProjectService_Add = new grpc.web.MethodDescriptor(
  '/proto.ProjectService/Add',
  grpc.web.MethodType.UNARY,
  proto.proto.ProjectRequest,
  proto.proto.ProjectResponse,
  /**
   * @param {!proto.proto.ProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ProjectResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ProjectServiceClient.prototype.add =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ProjectService/Add',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Add,
      callback);
};


/**
 * @param {!proto.proto.ProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ProjectResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ProjectServicePromiseClient.prototype.add =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ProjectService/Add',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Add);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ProjectRequest,
 *   !proto.proto.ProjectResponse>}
 */
const methodDescriptor_ProjectService_Update = new grpc.web.MethodDescriptor(
  '/proto.ProjectService/Update',
  grpc.web.MethodType.UNARY,
  proto.proto.ProjectRequest,
  proto.proto.ProjectResponse,
  /**
   * @param {!proto.proto.ProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ProjectResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ProjectServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ProjectService/Update',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Update,
      callback);
};


/**
 * @param {!proto.proto.ProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ProjectResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ProjectServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ProjectService/Update',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ProjectsRequest,
 *   !proto.proto.ProjectResponse>}
 */
const methodDescriptor_ProjectService_Completed = new grpc.web.MethodDescriptor(
  '/proto.ProjectService/Completed',
  grpc.web.MethodType.UNARY,
  proto.proto.ProjectsRequest,
  proto.proto.ProjectResponse,
  /**
   * @param {!proto.proto.ProjectsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ProjectResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ProjectServiceClient.prototype.completed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ProjectService/Completed',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Completed,
      callback);
};


/**
 * @param {!proto.proto.ProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ProjectResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ProjectServicePromiseClient.prototype.completed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ProjectService/Completed',
      request,
      metadata || {},
      methodDescriptor_ProjectService_Completed);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.ContextServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.ContextServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ContextsRequest,
 *   !proto.proto.ContextResponse>}
 */
const methodDescriptor_ContextService_Index = new grpc.web.MethodDescriptor(
  '/proto.ContextService/Index',
  grpc.web.MethodType.UNARY,
  proto.proto.ContextsRequest,
  proto.proto.ContextResponse,
  /**
   * @param {!proto.proto.ContextsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ContextResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ContextsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ContextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ContextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ContextServiceClient.prototype.index =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ContextService/Index',
      request,
      metadata || {},
      methodDescriptor_ContextService_Index,
      callback);
};


/**
 * @param {!proto.proto.ContextsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ContextResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ContextServicePromiseClient.prototype.index =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ContextService/Index',
      request,
      metadata || {},
      methodDescriptor_ContextService_Index);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ContextRequest,
 *   !proto.proto.ContextResponse>}
 */
const methodDescriptor_ContextService_Add = new grpc.web.MethodDescriptor(
  '/proto.ContextService/Add',
  grpc.web.MethodType.UNARY,
  proto.proto.ContextRequest,
  proto.proto.ContextResponse,
  /**
   * @param {!proto.proto.ContextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ContextResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ContextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ContextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ContextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ContextServiceClient.prototype.add =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ContextService/Add',
      request,
      metadata || {},
      methodDescriptor_ContextService_Add,
      callback);
};


/**
 * @param {!proto.proto.ContextRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ContextResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ContextServicePromiseClient.prototype.add =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ContextService/Add',
      request,
      metadata || {},
      methodDescriptor_ContextService_Add);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ContextRequest,
 *   !proto.proto.ContextResponse>}
 */
const methodDescriptor_ContextService_Update = new grpc.web.MethodDescriptor(
  '/proto.ContextService/Update',
  grpc.web.MethodType.UNARY,
  proto.proto.ContextRequest,
  proto.proto.ContextResponse,
  /**
   * @param {!proto.proto.ContextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ContextResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ContextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ContextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ContextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ContextServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ContextService/Update',
      request,
      metadata || {},
      methodDescriptor_ContextService_Update,
      callback);
};


/**
 * @param {!proto.proto.ContextRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ContextResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ContextServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ContextService/Update',
      request,
      metadata || {},
      methodDescriptor_ContextService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ContextsRequest,
 *   !proto.proto.ContextResponse>}
 */
const methodDescriptor_ContextService_Completed = new grpc.web.MethodDescriptor(
  '/proto.ContextService/Completed',
  grpc.web.MethodType.UNARY,
  proto.proto.ContextsRequest,
  proto.proto.ContextResponse,
  /**
   * @param {!proto.proto.ContextsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ContextResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ContextsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ContextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ContextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ContextServiceClient.prototype.completed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ContextService/Completed',
      request,
      metadata || {},
      methodDescriptor_ContextService_Completed,
      callback);
};


/**
 * @param {!proto.proto.ContextsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ContextResponse>}
 *     Promise that resolves to the response
 */
proto.proto.ContextServicePromiseClient.prototype.completed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ContextService/Completed',
      request,
      metadata || {},
      methodDescriptor_ContextService_Completed);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.TopicServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.TopicServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TopicsRequest,
 *   !proto.proto.TopicResponse>}
 */
const methodDescriptor_TopicService_Index = new grpc.web.MethodDescriptor(
  '/proto.TopicService/Index',
  grpc.web.MethodType.UNARY,
  proto.proto.TopicsRequest,
  proto.proto.TopicResponse,
  /**
   * @param {!proto.proto.TopicsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TopicResponse.deserializeBinary
);


/**
 * @param {!proto.proto.TopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TopicResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TopicResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TopicServiceClient.prototype.index =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TopicService/Index',
      request,
      metadata || {},
      methodDescriptor_TopicService_Index,
      callback);
};


/**
 * @param {!proto.proto.TopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TopicResponse>}
 *     Promise that resolves to the response
 */
proto.proto.TopicServicePromiseClient.prototype.index =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TopicService/Index',
      request,
      metadata || {},
      methodDescriptor_TopicService_Index);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TopicRequest,
 *   !proto.proto.TopicResponse>}
 */
const methodDescriptor_TopicService_Add = new grpc.web.MethodDescriptor(
  '/proto.TopicService/Add',
  grpc.web.MethodType.UNARY,
  proto.proto.TopicRequest,
  proto.proto.TopicResponse,
  /**
   * @param {!proto.proto.TopicRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TopicResponse.deserializeBinary
);


/**
 * @param {!proto.proto.TopicRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TopicResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TopicResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TopicServiceClient.prototype.add =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TopicService/Add',
      request,
      metadata || {},
      methodDescriptor_TopicService_Add,
      callback);
};


/**
 * @param {!proto.proto.TopicRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TopicResponse>}
 *     Promise that resolves to the response
 */
proto.proto.TopicServicePromiseClient.prototype.add =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TopicService/Add',
      request,
      metadata || {},
      methodDescriptor_TopicService_Add);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TopicRequest,
 *   !proto.proto.TopicResponse>}
 */
const methodDescriptor_TopicService_Update = new grpc.web.MethodDescriptor(
  '/proto.TopicService/Update',
  grpc.web.MethodType.UNARY,
  proto.proto.TopicRequest,
  proto.proto.TopicResponse,
  /**
   * @param {!proto.proto.TopicRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TopicResponse.deserializeBinary
);


/**
 * @param {!proto.proto.TopicRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TopicResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TopicResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TopicServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TopicService/Update',
      request,
      metadata || {},
      methodDescriptor_TopicService_Update,
      callback);
};


/**
 * @param {!proto.proto.TopicRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TopicResponse>}
 *     Promise that resolves to the response
 */
proto.proto.TopicServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TopicService/Update',
      request,
      metadata || {},
      methodDescriptor_TopicService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TopicsRequest,
 *   !proto.proto.TopicResponse>}
 */
const methodDescriptor_TopicService_Completed = new grpc.web.MethodDescriptor(
  '/proto.TopicService/Completed',
  grpc.web.MethodType.UNARY,
  proto.proto.TopicsRequest,
  proto.proto.TopicResponse,
  /**
   * @param {!proto.proto.TopicsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TopicResponse.deserializeBinary
);


/**
 * @param {!proto.proto.TopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TopicResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TopicResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.TopicServiceClient.prototype.completed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.TopicService/Completed',
      request,
      metadata || {},
      methodDescriptor_TopicService_Completed,
      callback);
};


/**
 * @param {!proto.proto.TopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TopicResponse>}
 *     Promise that resolves to the response
 */
proto.proto.TopicServicePromiseClient.prototype.completed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.TopicService/Completed',
      request,
      metadata || {},
      methodDescriptor_TopicService_Completed);
};


module.exports = proto.proto;

